module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "member-edit-form"
  }, [(!_vm.isSaving && !_vm.removeMode) ? [_c('div', {
    staticClass: "avatar-container"
  }, [_c('avatar', {
    attrs: {
      "profile-data": _vm.member,
      "profile-type": "developer",
      "size": "large",
      "show-xp-info": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "member-actions"
  }, [_c('span', {
    staticClass: "alias"
  }, [_vm._v(_vm._s(_vm.member.alias))]), _vm._v(" "), (_vm.member.modLevel !== 'owner') ? _c('label', {
    staticClass: "is-moderator"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.member.isModerator),
      expression: "member.isModerator"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.member.isModerator) ? _vm._i(_vm.member.isModerator, null) > -1 : (_vm.member.isModerator)
    },
    on: {
      "change": function($event) {
        _vm.saveButtonEnabled = true
      },
      "__c": function($event) {
        var $$a = _vm.member.isModerator,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.member.isModerator = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.member.isModerator = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.member.isModerator = $$c
        }
      }
    }
  }), _vm._v(" Is a Moderator\n            ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "button save",
    attrs: {
      "disabled": !_vm.saveButtonEnabled
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.saveMember($event)
      }
    }
  }, [_vm._v("Save Member Info")]), _vm._v(" "), (_vm.member.id !== _vm.myId) ? _c('button', {
    staticClass: "button remove",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.removeMode = true
      }
    }
  }, [_vm._v("Remove from Game")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "member-positions"
  }, _vm._l((_vm.positions), function(position) {
    return _c('div', {
      staticClass: "position"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.member.positions[position].checked),
        expression: "member.positions[position].checked"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(_vm.member.positions[position].checked) ? _vm._i(_vm.member.positions[position].checked, null) > -1 : (_vm.member.positions[position].checked)
      },
      on: {
        "change": function($event) {
          _vm.saveButtonEnabled = true
        },
        "__c": function($event) {
          var $$a = _vm.member.positions[position].checked,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.member.positions[position].checked = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.member.positions[position].checked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.member.positions[position].checked = $$c
          }
        }
      }
    }), _vm._v(" " + _vm._s(position))]), _vm._v(" "), _c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.member.positions[position].positionTitle),
        expression: "member.positions[position].positionTitle"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Role Title"
      },
      domProps: {
        "value": (_vm.member.positions[position].positionTitle)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.member.positions[position].positionTitle = $event.target.value
        }, function($event) {
          _vm.saveButtonEnabled = true
        }]
      }
    })])])
  }))] : _vm._e(), _vm._v(" "), (!_vm.isSaving && _vm.removeMode) ? [_c('section', {
    staticClass: "remove-user"
  }, [_c('h1', [_vm._v("Remove " + _vm._s(_vm.member.alias) + " from this game project?")]), _vm._v(" "), _c('button', {
    staticClass: "button minor",
    on: {
      "click": function($event) {
        _vm.removeMode = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": _vm.removeMember
    }
  }, [_vm._v("Yes, Remove This User")])])] : _vm._e(), _vm._v(" "), (_vm.isSaving) ? _c('saver-large') : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0b872ae6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Pages/Game/SubPages/GameMembersEditItem.vue
// module id = 819
// module chunks = 2